import React from 'react';
import { DotLoader } from 'react-spinners';

function BigLoader({
  color = '#FF7F27',
  size = 60,
  variant = 'fullscreen',
}) {
  const containerClass =
    variant === 'overlay'
      ? 'fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/30 backdrop-blur-sm'
      : 'fixed inset-0 z-50 flex flex-col items-center justify-center bg-white';

  return (
    <div className={containerClass} role="status" aria-live="polite">
      <DotLoader color={color} size={size} />
    </div>
  );
}

export default BigLoader;
